import React, { useState, useContext } from "react";
import { ApiContext } from "../context/ApiContext";
import { useHistory } from "react-router-dom";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NoPostYetforUser = () => {

    const { t } = useTranslation();

return(
<Link to="/recommend">
<div className="pointer card w-100 shadow-xss rounded-xxl border-0 ps-3 pe-3 pt-3 pb-2 mb-3">
    <div className="card-body rounded-0 text-left">
    <h2 className="fw-700 display1-size display2-md-size mb-3 text-grey-700">{t('NoPostYetforUser1')}</h2>
    
    
    </div>
    
</div>
</Link>
)
    
}

export default NoPostYetforUser;